export default "__VITE_ASSET__Cz$AcMMu__"